
 <template lang="">
 <UserLayout  pageTitle="Gestione clienti">
      <template #page-content="props" >
         
                    <!-- <v-card
                        class="form-card" 
                        outlined 
                        > -->
                        <FrmManageClients>
                        </FrmManageClients>
        
                    <!-- </v-card>  -->
           </template>
 </UserLayout> 
</template>
<script>
import UserLayout from "../layout/UserLayout";
import FrmManageClients from "../components/Management/FrmManageClients";
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
  components: {
    FrmManageClients,
    UserLayout, 
  },
};
</script>
 <style lang="">
</style>